import _ from 'lodash';
import AccountNavBar from './ui/AccountNavBar';
import Anchor from './ui/Anchor';
import AppController from './ui/AppController';
import AppWidget from './ui/AppWidget';
import Background from './ui/Background';
import Box from './ui/Box';
import Form from './ui/Form';
import Button from './ui/Button';
import Checkbox from './ui/Checkbox';
import CheckboxGroup from './ui/CheckboxGroup';
import Column from './ui/Column';
import ColumnStrip from './ui/ColumnStrip';
import Container from './ui/Container';
import DatePicker from './ui/DatePicker';
import Dropdown from './ui/DropDown';
import Element from './ui/Element';
import Footer from './ui/Footer';
import FormElement from './ui/FormElement';
import Gallery from './ui/Gallery';
import GoogleMap from './ui/GoogleMap';
import Header from './ui/Header';
import HiddenCollapsedElement from './ui/HiddenCollapsedElement';
import HoverBox from './ui/HoverBox';
import Popover from './ui/Popover';
import HtmlComponent from './ui/HtmlComponent';
import IFrame from './ui/IFrame';
import Image from './ui/Image';
import Link from './ui/Link';
import MobileMenu from './ui/MobileMenu';
import Node from './ui/Node';
import Native from './ui/Native';
import Page from './ui/Page';
import QuickActionBar from './ui/QuickActionBar';
import RadioButtonGroup from './ui/RadioButtonGroup';
import Repeater from './ui/Repeater';
import Slide from './ui/Slide';
import Slideshow from './ui/Slideshow';
import State from './ui/State';
import MultiStateBox from './ui/MultiStateBox';
import Table from './ui/Table';
import Text from './ui/Text';
import TextBox from './ui/TextBox';
import TextInput from './ui/TextInput';
import UploadButton from './ui/UploadButton';
import VectorImage from './ui/VectorImage';
import Menu from './ui/Menu';
import Video from './ui/Video';
import MenuContainer from './ui/MenuContainer';
import MediaBox from './ui/MediaBox';
import VideoBox from './ui/VideoBox';
import VideoBoxMute from './ui/VideoBoxMute';
import VideoBoxBigPlay from './ui/VideoBoxBigPlay';

import getTypes from './ui/Types';
import monitoring from './privates/monitoring';

const classes = {
    AccountNavBar,
    Anchor,
    AppController,
    AppWidget,
    Background,
    Box,
    Form,
    Button,
    Checkbox,
    CheckboxGroup,
    Column,
    ColumnStrip,
    Container,
    DatePicker,
    Dropdown,
    Element,
    Footer,
    FormElement,
    Gallery,
    GoogleMap,
    Header,
    HiddenCollapsedElement,
    HoverBox,
    HtmlComponent,
    IFrame,
    Image,
    Link,
    MobileMenu,
    Node,
    Native,
    Page,
    QuickActionBar,
    RadioButtonGroup,
    Repeater,
    Slide,
    Slideshow,
    State,
    MultiStateBox,
    Table,
    Text,
    TextBox,
    TextInput,
    UploadButton,
    VectorImage,
    Menu,
    Video,
    Popover,
    MenuContainer,
    MediaBox,
    VideoBox,
    VideoBoxMute,
    VideoBoxBigPlay
};

const ui = _.assign(_.mapValues(classes, (clazz) => monitoring.monitorComponent(clazz)), {getTypes});
ui.registerComponent = (sdkType, module, allowTypeOverride) => {
    if(!allowTypeOverride && ui[sdkType]){
        return false;
    }
    ui[sdkType] = monitoring.monitorComponent(module, allowTypeOverride);
    return true;
};

export default ui;
